import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetStore } from '@pages/admin/article/store/slice';
import { Header } from '@pages/admin/article/article-form/header/Header';
import { Base } from '@pages/admin/article/article-form/base/Base';
import { Content } from '@pages/admin/article/article-form/content/Content';



export const ArticleForm = () => {

	const dispatch = useDispatch();
	const dispatchResetStore = () => dispatch(resetStore());

	useEffect(() => {
		return () => {
			dispatchResetStore();
		}
	}, []);

	return (
		<div className='article-form'>
			<Header />
			<Base />
			<Content />
		</div>
	);
};